import React, { PropTypes } from 'react'

export default function Dossier(props) {
	return <a className='article-tease article-tease--tall article-tease--dossier' href={ props.permalink }>
		<div className='article-tease__title'>{ props.post_title }</div>
		<div className='article-tease__sub-title' dangerouslySetInnerHTML={{ __html: props.chapo }} />
		<div className='article-tease__image--dossier'><img src={ props.thumbnail } alt={ props.chapo }/></div>
	</a>
}

Dossier.propTypes = {
	permalink: PropTypes.string.isRequired,
	thumbnail: PropTypes.string,
	post_title: PropTypes.string.isRequired,
	chapo: PropTypes.string,
}



// WEBPACK FOOTER //
// ./js/website/react_components/teasers/Dossier.js